import React from 'react';
import PropTypes from 'prop-types';
import BulkEditInstancesPage from '../components/App/BulkEditInstances';

const BulkEditInstancesRoute = ({ basePath }) => {
  return <BulkEditInstancesPage basePath={basePath} />;
};

BulkEditInstancesRoute.propTypes = {
  basePath: PropTypes.string.isRequired,
};

export default BulkEditInstancesRoute;
